export const investigationRefreshHeader = 'X-Stationzero-Investigation-Project'

/** Only this screen's read requests may suppress Inertia's error modal. A
 * cancelled navigation or another project's failure must not change this UI.
 */
export function isInvestigationRefresh(config: unknown, scope: string): boolean {
  if (!config || typeof config !== 'object' || !('headers' in config)) return false
  const headers = config.headers
  if (!headers || typeof headers !== 'object') return false
  const values = headers as Record<string, unknown>
  return (values[investigationRefreshHeader] ?? values[investigationRefreshHeader.toLowerCase()]) === scope
}
